import { render, staticRenderFns } from "./CreateConsentForm.vue?vue&type=template&id=693fea4d&"
import script from "./CreateConsentForm.vue?vue&type=script&lang=js&"
export * from "./CreateConsentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports